import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import styles from './progress-bar.styl';


@WixConnect(styles)
export default class ProgressBar extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
    fillClassName: React.PropTypes.string,
    inputClassName: React.PropTypes.string,
    orientation: React.PropTypes.string,
    step: React.PropTypes.number,
    progress: React.PropTypes.number,
    onChange: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onBlur: React.PropTypes.func,
  };

  static defaultProps = {
    orientation: 'horizontal',
    step: 0.05,
    progress: 0,
    onBlur: _.noop,
    onFocus: _.noop,
    onChange: _.noop,
  };

  componentDidMount() {
    // 'orient' is not supported by React but
    // is required for Firefox. Setting manually.
    // https://github.com/facebook/react/issues/2453
    this.rangeInput.setAttribute('orient', this.props.orientation);
    this.rangeInput.addEventListener('input', this.props.onChange);
    // TODO: remove after React 16 release
    // https://github.com/facebook/react/issues/554
    this.rangeInput.addEventListener('change', this.props.onChange);
  }

  componentWillReceiveProps(nextProps) {
    this.rangeInput.value = nextProps.progress;
  }

  componentWillUnmount() {
    this.rangeInput.removeEventListener('change', this.props.onChange);
    this.rangeInput.removeEventListener('input', this.props.onChange);
  }

  @autobind
  setRef(ref) {
    this.rangeInput = ref;
  }

  render() {
    const {
      className, fillClassName, inputClassName, orientation, progress, step,
      onBlur, onFocus,
    } = this.props;

    const progressProp = orientation === 'horizontal' ? 'width' : 'height';

    return (
      <div styleName={`progress-bar progress-bar--${orientation}`}
           className={className}>
        <div styleName="progress-bar__fill"
             className={fillClassName}
             style={{
               [progressProp]: `${progress}%`,
             }} />
        <input styleName="progress-bar__input"
               ref={this.setRef}
               type="range"
               min="0"
               max="100"
               className={inputClassName}
               defaultValue={progress}
               step={step}
               onBlur={onBlur}
               onFocus={onFocus} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/progress-bar/progress-bar.js